var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"filterPanel"},'component',_vm.$attrs,false),[(_vm.title)?_c('h5',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"filterPanel__body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }